import * as React from 'react'
import { FilterProps, Filter } from 'react-admin'
import { PayoutSummarizedListFiltersArray } from './Filters'

const PayoutSummarizedFilter: React.FC<Omit<FilterProps, 'children'>> = (
  props
) => {
  return (
    <Filter {...props}>
      {PayoutSummarizedListFiltersArray.map((item) => item.FilterInput)}
    </Filter>
  )
}

export default PayoutSummarizedFilter
